import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { StorageKeys } from '~/atoms/StorageKeys'

export const dontShowAgainAtom = atomWithStorage<Record<string, boolean>>(
  StorageKeys.DontShowAgain,
  {},
)

export const useDontShowAgain = () => {
  const [dontShowAgain, setDontShowAgain] = useAtom(dontShowAgainAtom)

  const setDontShowAgainKey = (
    key: string | undefined,
    value: boolean = true,
  ) => {
    if (!key) return
    setDontShowAgain((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const isDontShowAgainSet = (key: string | undefined) =>
    key ? !!dontShowAgain[key] : false

  return [isDontShowAgainSet, setDontShowAgainKey] as const
}
